module.exports = __webpack_public_path__ + "static/img/topL.81e19b7c.png";